import dayjs from "dayjs";
import { supabaseClient } from "supabase";

export type QueryEventsCountParams = {
  eventType: "published" | "draft" | "archieved";
  title?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  isMunicipality?: boolean;
  userUid?: string;
  madeByOrganizer?: boolean;
};

export const queryEventsCount = async ({
  eventType,
  title,
  startDate,
  endDate,
  isMunicipality,
  userUid,
  madeByOrganizer,
}: QueryEventsCountParams) => {
  const { data: userData } = await supabaseClient.auth.getUser();

  const selectQuery =
    isMunicipality !== undefined || userUid
      ? "*,organizers!inner(name)"
      : "*";

  let query = supabaseClient
    .from("events")
    .select(selectQuery, { count: "exact" });

  const user = await supabaseClient
    .from("users")
    .select("*")
    .eq("auth_uid", userData.user?.id || "")
    .single();
  if (user.data.organizer_id && user.data.organizer_id !== null) {
    query = query.eq("organizer_id", user.data.organizer_id);
  }

  if (title) {
    query = query.ilike("title", `%${title}%`);
  }

  if (startDate) {
    query = query.gte("start_time", dayjs(startDate).subtract(1).toISOString());
  }
  if (endDate) {
    query = query.lte("start_time", dayjs(endDate).add(1, "day").toISOString());
  }

  if (isMunicipality !== undefined) {
    query = query.eq("organizers.is_municipality", isMunicipality);
  }

  if (userUid) {
    query = query.eq("organizers.uid", userUid);
  }

  if (madeByOrganizer) {
    query = query.eq("made_by_organizer", true);
  }

  if (eventType === "published") {
    const { count, error } = await query
      .eq("published", true)
      .gte("start_time", dayjs());
    if (error) {
      throw error;
    }
    return { count };
  } else if (eventType === "draft") {
    const { count, error } = await query.eq("published", false);
    if (error) {
      throw error;
    }
    return { count };
  } else {
    // Keep this in sync with the archived filter in queryEvents.ts so the tab
    // badge matches the rows shown in the list.
    const { count, error } = await query.lt("start_time", dayjs());
    if (error) {
      throw error;
    }
    return { count };
  }
};
